import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { SpsFlags } from './SpsFlags';

export function renderFlags () {
    return new Promise ((resolve) => {
        if (document.getElementById('sps-flags-root')) {
            ReactDOM.render(
                React.createElement(SpsFlags, {
                    closeSpsFlags: () => resolve()
                }),
                document.getElementById('sps-flags-root')
            );
        }
    });
}
